export const DEPARTMENT_VISUALS = {
  shoe: "/brand/generated/catalog/departments/shoe.png",
};

export const CATEGORY_VISUALS = {
  executive: "/brand/generated/catalog/brands/executive.png",
  uniqlo: "/brand/generated/catalog/brands/uniqlo.png",
  skechers: "/brand/generated/catalog/categories/skechers.png",
  safi: "/brand/generated/catalog/brands/safi.png",
  skintific: "/brand/generated/catalog/brands/skintific.png",
  skinfitic: "/brand/generated/catalog/brands/skintific.png",
  wardah: "/brand/generated/catalog/brands/wardah.png",
};
